import "./App.css";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider, useAuth } from "./context/AuthContext";

import Home from "./pages/Home";
import MenuPage from "./pages/MenuPage";
import Checkout from "./pages/Checkout";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import DevControl from "./pages/DevControl";

import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import LiveOrders from "./pages/admin/LiveOrders";
import MenuManagement from "./pages/admin/MenuManagement";
import OpeningHours from "./pages/admin/OpeningHours";
import DeliverySettings from "./pages/admin/DeliverySettings";
import OrderHistory from "./pages/admin/OrderHistory";

function Protected() {
  const { admin } = useAuth();
  if (admin === null) return <div className="min-h-screen flex items-center justify-center text-brand-teal">Loading…</div>;
  if (!admin) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <CartProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/menu" element={<MenuPage />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/payment/success" element={<PaymentSuccess />} />
              <Route path="/payment/cancel" element={<PaymentCancel />} />
              <Route path="/dev-control" element={<DevControl />} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route element={<Protected />}>
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<LiveOrders />} />
                  <Route path="menu" element={<MenuManagement />} />
                  <Route path="hours" element={<OpeningHours />} />
                  <Route path="delivery" element={<DeliverySettings />} />
                  <Route path="history" element={<OrderHistory />} />
                </Route>
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-center" richColors />
        </CartProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
